<rr-ai-chat></rr-ai-chat>

<div class="row memberrow align-center">
  <div class="member" *ngFor="let member of teammembers; let i = index">
    <rr-icon
      name="user"
      class="defaultuser"
      [title]="member?.prename + ' ' + member?.lastname"
      *ngIf="
        i < showLimit &&
        !member?.avatar &&
        (!member?.prename ||
          !member?.lastname ||
          member?.prename == '' ||
          member?.lastname == '')
      "
    ></rr-icon>
    <div
      class="defaultuser tiny"
      [title]="member?.prename + ' ' + member?.lastname"
      *ngIf="
        i < showLimit &&
        !member?.avatar &&
        member?.prename != '' &&
        member?.lastname != ''
      "
    >
      {{ member?.prename[0] }}{{ member?.lastname[0] }}
    </div>
    <img
      class="avatar"
      *ngIf="i < showLimit && member?.avatar"
      [src]="
        serverurl +
          '/public/avatars/' +
          member?.id +
          '.png?' +
          member.refreshtoken || ''
      "
      alt="User Avatar"
    />
  </div>
  @if(teammembers.length >= showLimit){
  <div
    class="defaultuserlimit defaultuser tiny"
    [title]="teammembers.length + ' Team-Member'"
  >
    {{ teammembers.length - showLimit }}+
  </div>
  }
</div>
<rr-icon
  name="userplus"
  color="baisc"
  [ngClass]="inviteDisabled === true ? 'disabled' : 'pointer'"
  class="roundicon"
  (click)="inviteDisabled === true ? null : openSettings(3)"
></rr-icon>
